import { getLocalStorage, setLocalStorage } from './localStorage';
import { trackClickEvent } from '@/common/js/omega';
export const setCookie = (name: string, value: any, hours: number) => {
    let date = new Date()
    let ms = hours * 3600 * 1000
    date.setTime(date.getTime() + ms)
    document.cookie = name + '=' + value + '; PATH=/; expires=' + date.toUTCString()
}

export const getCookie = (name: string) => {
    let cookies = document.cookie
    let cookieMap = {}
    // eslint-disable-next-line
    cookies && cookies.split('; ').map(item => {
        let t = item.split('=')
        cookieMap[t[0]] = t[1]
    })
    return cookieMap[name]
}

export const getUrlParam = (name: string) => {
    const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
    const r = window.location.search.substr(1).match(reg)
    if (r != null) return r[2]
    return null
}

/**
 * 解析url参数，包括search和hash
 * @example ?id=12345&a=b
 * @return Object {id:12345,a:b}
 */
export function urlParse(url: URL) {
    const search = url.search
    const index = url.hash.indexOf('?');
    const hash = ~index ? url.hash.substr(index) : '';
    const reg = /[?&][^?&]+=[^?&]+/g;
    const arr = (search + hash).match(reg);
    let obj = {};
    if (arr) {
        arr.forEach((item: any) => {
            let tempArr = item.substring(1).split('=');
            let key = decodeURIComponent(tempArr[0]);
            let val = decodeURIComponent(tempArr[1]);
            obj[key] = val;
        })
    }
    return obj;
}

export const setFormatTime = (time: any) => {
    const date = new Date(time)
    return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
}

export const changeUrlSearchParam = (name: string, value: string, searchString?: string | undefined) => {
    let search = window.location.search.substr(1).split('&')
    if (searchString) {
        search = searchString.substr(1).split('&')
    }
    let searchObj = {}
    search.forEach((item) => {
        if (item !== '') {
            let searchItem = item.split('=')
            searchObj[searchItem[0]] = searchItem[1]
        }
    })
    // if (searchObj[name]) {
    searchObj[name] = value
    // }
    let searchStr = ''
    Object.keys(searchObj).forEach((item, index) => {
        let prefix = index === 0 ? '?' : '&'
        searchStr = searchStr + prefix + item + '=' + searchObj[item]
    })
    return searchStr
}

function arrIndexOf(arr: string | any[], v: string) {
    for (var i = 0; i < arr.length; i++) {
        if (arr[i] === v) { return i }
    }
    return -1
}

export const removeClass = (obj: { className: string; }, className: string) => {
    if (className !== '') {
        var arrClassName = obj.className.split(' ')
        var _index = arrIndexOf(arrClassName, className)
        if (_index !== -1) {
            arrClassName.splice(_index, 1)
            obj.className = arrClassName.join(' ')
        }
    }
}

export const addClass = (obj: { className: string; }, className: string) => {
    obj.className += " " + className
}

//删除指定参数值
export const deleteUrlSearchParam = (url: string, ref: string) => {
    var str = "";

    if (url.indexOf('?') !== -1)
        str = url.substr(url.indexOf('?') + 1);
    else
        return url;
    var arr = [];
    var returnurl = "";
    if (str.indexOf('&') !== -1) {
        arr = str.split('&');
        for (let i in arr) {
            if (arr[i].split('=')[0] !== ref) {
                returnurl = returnurl + arr[i] + "&";
            }
        }
        return url.substr(0, url.indexOf('?')) + "?" + returnurl.substr(0, returnurl.length - 1);
    }
    else {
        arr = str.split('=');
        if (arr[0] === ref)
            return url.substr(0, url.indexOf('?'));
        else
            return url;
    }
}

// 缓存接口
export const cacheData = (cacheName: string, getDataFunc: () => Promise<any>, callback: (arg0: any) => void) => {

    let Response = getLocalStorage(cacheName);
    if (Response) {
        callback(Response);
    }
    getDataFunc().then(res => {
        if (+res.status === 0) {
            setLocalStorage(cacheName, res);
        }
        callback(res)
    })
}

export const isNumber = (value: any) => {
    return parseFloat(value).toString() !== 'NaN'
}

export const DateFormat = (date: Date, fmt = "yyyy-MM-dd hh:mm:ss") => {
    const o: { [key: string]: number } = {
        "M+": date.getMonth() + 1, //月份
        "d+": date.getDate(), //日
        "h+": date.getHours(), //小时
        "m+": date.getMinutes(), //分
        "s+": date.getSeconds(), //秒
        "q+": Math.floor((date.getMonth() + 3) / 3), //季度
        S: date.getMilliseconds(), //毫秒
    };
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(
            RegExp.$1,
            (date.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
    }
    for (var k in o) {
        if (new RegExp("(" + k + ")").test(fmt))
            fmt = fmt.replace(
                RegExp.$1,
                RegExp.$1.length === 1
                    ? `${o[k]}`
                    : ("00" + o[k]).substr(("" + o[k]).length)
            );
    }
    return fmt;
};

export function getIpData() {
    fetch('https://ipapi.co/json/').then((res)=>res.json()).then((res) => {
        trackClickEvent('tech_ibt_csglobal_ip_info', {
            ip: res ? res.ip : '',
            user_name: getCookie('user_name'),
        });
    }, (error) => {
    });
}
